const EXPERIENCE_TYPE = {
    CURRENT: 'current',
    NEW: 'new'
};

const COLOR_SWATCH_DISPLAY = {
    CURRENT: 'current',
    SHOW_HYBRID: 'showHybrid'
};

const NEXT_DAY_DELIVERY_MESSAGE = {
    ORDER_NOW: 'Order now, get it tomorrow',
    ORDER_TODAY: 'Order today'
};

const ORDER_TYPE = {
    STANDARD: 'standard',
    BOPIS: 'bopis',
    SDD: 'sdd'
};

const SHOW_ML_DRIVEN_PROMOS = {
    CURRENT: 'hidePromos',
    NEW: 'showPromos'
};

const ML_VS_CONSTRUCTOR = {
    ML: 'ml',
    CONSTRUCTOR: 'constructor'
};

const SHOW_BASKET_CC_BANNER_8_PERCENT_BACK = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const SHOW_PRODUCT_THUMBNAILS_CHECKOUT = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const PURCHASED_FLAG_ON_GRID_PAGES_EXPERIENCE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const TRENDING_CONTENT = {
    CHALLENGER_ONE: 'challengerOne'
};

const REORDER_FULFILLMENT_OPTIONS_EXPERIENCE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const REORDER_SECTION_PAGE_PDP_EXPERIENCE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree'
};

const SHOW_HIGHLIGHT_LAYER_WITH_PDP = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne'
};

const SOCIAL_PROOF_PDP = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const SHOW_SKU_OPTIONS_PLP = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const BI_SIGN_IN_UP_ACCOUNT_COPY = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const SIMPLIFIED_PDP_COMPARE = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree',
    CHALLENGER_FOUR: 'challengerFour'
};

const STICKY_NAV_BAR_PDP = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const HIGHLIGHT_TOTAL_SAVINGS_BASKET = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree',
    CHALLENGER_FOUR: 'challengerFour',
    CHALLENGER_FIVE: 'challengerFive'
};

const RELATED_SEARCHES_EXPERIENCE = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree'
};

const UPDATE_FAST_SHIPPING_COPY_MEGANAV_SM = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree'
};

const ADD_HIGHLIGHT_PILLS = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const FREE_SHIPPING_PROGRESS_BAR_ATB = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

const BOTTOM_NAV_OFFERS_EXPERIENCE = {
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo',
    CHALLENGER_THREE: 'challengerThree',
    CHALLENGER_FOUR: 'challengerFour',
    CHALLENGER_FIVE: 'challengerFive'
};

const ADD_ITEM_SAVINGS_BASKET = {
    CONTROL: 'control',
    CHALLENGER_ONE: 'challengerOne',
    CHALLENGER_TWO: 'challengerTwo'
};

export {
    ADD_ITEM_SAVINGS_BASKET,
    ADD_HIGHLIGHT_PILLS,
    STICKY_NAV_BAR_PDP,
    REORDER_FULFILLMENT_OPTIONS_EXPERIENCE,
    EXPERIENCE_TYPE,
    COLOR_SWATCH_DISPLAY,
    NEXT_DAY_DELIVERY_MESSAGE,
    ORDER_TYPE,
    SHOW_ML_DRIVEN_PROMOS,
    ML_VS_CONSTRUCTOR,
    SHOW_BASKET_CC_BANNER_8_PERCENT_BACK,
    SHOW_PRODUCT_THUMBNAILS_CHECKOUT,
    PURCHASED_FLAG_ON_GRID_PAGES_EXPERIENCE,
    TRENDING_CONTENT,
    SHOW_HIGHLIGHT_LAYER_WITH_PDP,
    REORDER_SECTION_PAGE_PDP_EXPERIENCE,
    SOCIAL_PROOF_PDP,
    SHOW_SKU_OPTIONS_PLP,
    BI_SIGN_IN_UP_ACCOUNT_COPY,
    SIMPLIFIED_PDP_COMPARE,
    HIGHLIGHT_TOTAL_SAVINGS_BASKET,
    RELATED_SEARCHES_EXPERIENCE,
    UPDATE_FAST_SHIPPING_COPY_MEGANAV_SM,
    BOTTOM_NAV_OFFERS_EXPERIENCE,
    FREE_SHIPPING_PROGRESS_BAR_ATB
};
